import React from 'react';
import { Form, FormInstance, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { AttributeOptionsEditor } from './AttributeOptionsEditor';

interface EditAttributeModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  form: FormInstance;
  onValuesChange: (changedValues: any, allValues: any) => void;
  loading?: boolean;
}

export const EditAttributeModal: React.FC<EditAttributeModalProps> = ({
  open,
  onCancel,
  onOk,
  form,
  onValuesChange,
  loading = false,
}) => {
  const { t } = useTranslation('crops');
  return (
    <Modal
      title={t('attributes.editTitle')}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={loading}
      afterClose={() => form.resetFields()}
      okText={t('common:actions.save')}
      cancelText={t('common:actions.cancel')}
    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          label={t('attributes.name')}
          name="name"
          rules={[{ required: true, message: t('details.createAttributeModal.nameRequired') }]}
        >
          <Input placeholder={t('attributes.namePlaceholderPlain')} />
        </Form.Item>
        <Form.Item label={t('common:labels.description')} name="description">
          <Input.TextArea rows={3} placeholder={t('attributes.descriptionPlaceholder')} allowClear />
        </Form.Item>
        <Form.List name="options">
          {(fields, operations) => (
            <AttributeOptionsEditor
              fields={fields}
              operations={operations}
              helperText={t('attributes.options.helper')}
              emptyText={t('attributes.options.emptySet')}
              listName={['options']}
            />
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};